import * as React from 'react'

export const useFocus = <T = HTMLInputElement>({
  onMouseUp,
  onClick,
}: React.InputHTMLAttributes<T>) => {
  const [focused, setFocused] = React.useState(false)
  const [isClickFromMouse, setIsClickFromMouse] = React.useState(false)

  const handleTab = (e: KeyboardEvent): void => {
    if (e.keyCode === 9) {
      setFocused(true)
    }
  }

  React.useEffect(() => {
    window.addEventListener('keydown', handleTab)

    return () => window.removeEventListener('keydown', handleTab)
  }, [])

  const handleMouseUp = (e: React.MouseEvent<HTMLLabelElement>) => {
    setIsClickFromMouse(true)

    if (onMouseUp) {
      onMouseUp(e as unknown as React.MouseEvent<T>)
    }
  }

  const handleClick: typeof onClick = (e) => {
    if (isClickFromMouse) {
      setFocused(false)
      setIsClickFromMouse(false)
    }

    if (onClick) {
      onClick(e)
    }
  }

  return {
    focused,
    handleClick,
    handleMouseUp,
  }
}
